define('meeting-modal/organizerPIN/edit-organizer-pin',['require','knockout','i18next','plugins/dialog','api-access'],function (require) {
    var ko = require('knockout');
    var i18n = require('i18next');
    var dialog = require('plugins/dialog');
    var userApi = require('api-access').user;

    var OrganizerPINEditor = function (organizerPINN, saveCallback) {
        var self = this;

        self.close = function () {
            dialog.close(self);
        };

        self.cancel = function () {
            self.close();
        };

        self.saveOrganizerPIN = function () {
            if (self.organizerPIN.isValid()) {
                self.close();
                userApi.updateSettings({conferenceModeratorPin: self.organizerPIN()}).then(
                    saveCallback(self.organizerPIN())
                );
            }
        };

        self.oldOrganizerPIN = organizerPINN;
        self.organizerPIN = ko.observable(organizerPINN).extend({
            required: {
                message: i18n.t('error.organizerPIN.required')
            },
            minLength: {
                params: 4,
                message: i18n.t('error.organizerPIN.minLength')
            },
            pattern: {
                params: '^[0-9]+$',
                message: i18n.t('error.organizerPIN.digitsOnly')
            }
        });
    };

    OrganizerPINEditor.show = function (organizerPIN, saveCallback) {
        self.editMode = organizerPIN && organizerPIN.length > 0;
        dialog.show(new OrganizerPINEditor(organizerPIN, saveCallback));
    };

    return OrganizerPINEditor;
});

